// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"sortDropdown_dropdown_3lO6Sac","dropdownTrigger":"sortDropdown_dropdownTrigger_T4AS8W6","dropdownIcon":"sortDropdown_dropdownIcon_3PWXio4"};